import AreaTemplate from '../AreaTemplate';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'ElectricalContractor',
  name: 'Electrician Solutions Fresno — Dinuba',
  description: 'Licensed electrician serving Dinuba, CA. C-10 certified electrical contractor for residential and commercial electrical work in Dinuba and Tulare County.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Dinuba',
    addressRegion: 'CA',
    postalCode: '93618',
    addressCountry: 'US',
  },
  geo: { '@type': 'GeoCoordinates', latitude: '36.5438', longitude: '-119.3876' },
  url: 'https://electriciansolutionsfresno.com/areas/dinuba',
  telephone: '+1-559-123-4567',
  priceRange: '$$',
  areaServed: { '@type': 'City', name: 'Dinuba', '@id': 'https://en.wikipedia.org/wiki/Dinuba,_California' },
};

const faqs = [
  {
    q: 'Do you provide electrician services in Dinuba, CA?',
    a: 'Yes! Electrician Solutions Fresno serves all of Dinuba, CA and surrounding Tulare County. Our C-10 licensed electricians handle residential electrical work, commercial installations, agricultural electrical systems, and 24/7 emergency services throughout Dinuba.',
  },
  {
    q: 'Can you work on industrial and packing house electrical in Dinuba?',
    a: 'Absolutely. Dinuba has significant agricultural processing and industrial electrical needs. We install and service three-phase power systems, industrial panels, cold storage electrical, conveyor wiring, and packing house lighting throughout the Dinuba area.',
  },
  {
    q: 'How fast can you respond to electrical emergencies in Dinuba?',
    a: 'Dinuba is about 35 miles south-east of Fresno. Our emergency electricians typically arrive in Dinuba within 50–75 minutes, 24 hours a day, 7 days a week.',
  },
  {
    q: 'Can you upgrade electrical panels for older Dinuba homes?',
    a: 'Yes. Many Dinuba homes have older 60A or 100A panels that need upgrading for modern electrical loads including AC, EV chargers, and electric appliances. We upgrade to 200A service with all City of Dinuba permits included.',
  },
  {
    q: 'What areas near Dinuba do you cover?',
    a: 'We serve all of Dinuba plus Alta Sierra, Orosi, Cutler, London, and rural Tulare County properties between Visalia and Reedley. We are the go-to electrical contractor for the entire Kaweah River corridor.',
  },
  {
    q: 'Do you install LED lighting upgrades in Dinuba commercial buildings?',
    a: 'Yes. We perform LED lighting retrofits for Dinuba commercial properties, packing facilities, and agricultural buildings, significantly reducing electricity costs on high PG&E bills common in the Central Valley.',
  },
];

const DinubaPage = () => (
  <AreaTemplate
    area="Dinuba"
    areaSlug="dinuba"
    state="CA"
    county="Tulare County"
    population="27,000+"
    description="Electrician Solutions Fresno provides expert C-10 licensed electrical services throughout Dinuba, CA and surrounding Tulare County. Located at the heart of Central California's agricultural region, Dinuba requires an electrical contractor with expertise in both residential homes and the area's significant packing house and agricultural processing operations. Our certified Dinuba electricians deliver reliable solutions for every electrical need."
    neighborhoods={['Downtown Dinuba', 'North Dinuba', 'Alta Sierra', 'El Monte Way', 'Crawford Ave Corridor', 'East Dinuba', 'Orosi Area', 'Cutler Vicinity']}
    nearbyAreas={[
      { name: 'Reedley', slug: 'reedley' },
      { name: 'Visalia', slug: 'visalia' },
      { name: 'Tulare', slug: 'tulare' },
      { name: 'Sanger', slug: 'sanger' },
      { name: 'Fresno', slug: 'fresno' },
    ]}
    faqs={faqs}
    heroImage="https://public.readdy.ai/ai/img_res/9674d705b6e17c4196f443c13ed7aec8.jpg"
    heroImageAlt="Licensed Electrician in Dinuba CA"
    teamImage="https://readdy.ai/api/search-image?query=Professional%20electrician%20crew%20in%20matching%20uniforms%20standing%20in%20front%20of%20Dinuba%20California%20landscape%20with%20grape%20vineyards%20and%20agricultural%20fields%20blue%20sky%20showing%20deep%20community%20roots%20in%20Tulare%20County%20agricultural%20region&width=800&height=600&seq=dinuba_team_001&orientation=landscape"
    teamImageAlt="Electrician Solutions team serving Dinuba CA"
    schema={schema}
  />
);

export default DinubaPage;
